import React, { useMemo } from 'react'
import ReactPhoneInput from 'react-phone-input-material-ui'
import 'react-phone-input-material-ui/lib/style.css'

import YumInputShrink from '../YumInput/YumInputShrink'
import YumInput from '../YumInput/YumInput'

interface YumPhoneInputProps {
  label: string
  name: string
  value: string
  required?: boolean
  error?: boolean
  style?: React.CSSProperties
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const YumPhoneInput = ({ label, name, value, required, error, style, onChange }: YumPhoneInputProps) => {
  const defaultCountry = null

  // Memoize the component so its reference stays stable across re-renders.
  // Without this, a new component is created on every keystroke,
  // causing React to unmount/remount the input and lose focus.
  const PhoneField = useMemo(
    () => (props: React.ComponentProps<typeof YumInputShrink>) => (
      <YumInput shrink {...props} required={required} error={error} />
    ),
    [required, error],
  )
  // Convert the library callback into a regular input change event.
  return (
    <ReactPhoneInput
      containerStyle={style}
      inputStyle={style}
      //defaultCountry={defaultCountry || 'us'}
      label={label}
      //type="tel"
      //name={name}
      value={value}
      inputProps={{ name, required }}
      onChange={(rawValue, data, event, formattedValue) =>
        onChange({
          target: { value: formattedValue, name },
        } as React.ChangeEvent<HTMLInputElement>)
      }
      component={PhoneField}
    />
  )
}

export default YumPhoneInput
